export const INDUSTRIES_WITH_ACTIVITY_CONTENT = [
  "vehicle",
  "etrade",
  "IT",
  "agriculture",
  "art",
  "beauty",
  "medicine",
];

export const industryHasActivityContent = (industry) =>
  INDUSTRIES_WITH_ACTIVITY_CONTENT.includes(industry);

export const isValidSearchID = (searchID) =>
  searchID && searchID !== "undefined" && searchID !== "null";

export const pickIndustryActivitySliceForPersist = (industry, slice) => {
  if (!industry || !slice) {
    return null;
  }

  switch (industry) {
    case "vehicle":
      return slice.differentialvat
        ? { differentialvat: slice.differentialvat }
        : null;
    case "etrade":
      return slice.etradesells ? { etradesells: slice.etradesells } : null;
    case "IT":
      return slice.ittype ? { ittype: slice.ittype } : null;
    case "agriculture":
      return slice.agriculturetype
        ? { agriculturetype: slice.agriculturetype }
        : null;
    case "art":
      return slice.arttype ? { arttype: slice.arttype } : null;
    case "beauty":
      return slice.beautyproductsales
        ? { beautyproductsales: slice.beautyproductsales }
        : null;
    case "medicine":
      return slice.medicinetype ? { medicinetype: slice.medicinetype } : null;
    default:
      return null;
  }
};

const hasTruthyFlag = (obj, keys) =>
  keys.some((key) => Boolean(obj?.[key]));

export const isIndustryActivityAnswered = (industry, industryspecifics) => {
  if (!industryHasActivityContent(industry)) {
    return true;
  }

  const slice = industryspecifics?.[industry];
  if (!slice) {
    return false;
  }

  switch (industry) {
    case "vehicle":
      return hasTruthyFlag(slice.differentialvat, [
        "automotivepartstrading",
        "trading",
        "service",
        "other",
      ]);
    case "etrade":
      return hasTruthyFlag(slice.etradesells, [
        "physicalproducts",
        "services",
        "intellectualproperty",
        "other",
      ]);
    case "IT":
      return hasTruthyFlag(slice.ittype, [
        "wagereview",
        "projectwork",
        "ownprodsoftdev",
        "other",
      ]);
    case "agriculture":
      return hasTruthyFlag(slice.agriculturetype, [
        "livestockfarming",
        "cropproduction",
        "other",
      ]);
    case "art":
      return hasTruthyFlag(slice.arttype, [
        "createartworks",
        "performingartist",
        "tradeartworks",
        "other",
      ]);
    case "beauty":
      return (
        slice.beautyproductsales?.status === "yes" ||
        slice.beautyproductsales?.status === "no"
      );
    case "medicine":
      return hasTruthyFlag(slice.medicinetype, [
        "doctor",
        "pharmacy",
        "nurse",
        "vet",
        "other",
      ]);
    default:
      return false;
  }
};

export const getIndustryActivityTitle = (industry, i18n) => {
  switch (industry) {
    case "IT":
      return i18n.t("searchflow.itindustryquestion");
    case "vehicle":
      return i18n.t("searchflow.differentialvatquestion");
    case "etrade":
      return i18n.t("searchflow.etradetypequestion");
    case "agriculture":
      return i18n.t("searchflow.agricultureindustryquestion");
    case "art":
      return i18n.t("searchflow.artindustryquestion");
    case "beauty":
      return i18n.t("searchflow.beautyindustryquestion");
    case "medicine":
      return i18n.t("searchflow.medicinetypequestion");
    default:
      return "";
  }
};
